/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type ReplyListContainer5_comment = {
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly status: COMMENT_STATUS;
    readonly id: string;
    readonly replies: {
        readonly viewNewEdges: ReadonlyArray<{
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly replyCount: number;
                readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment" | "ReplyListContainer6_comment">;
            };
        }> | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly replyCount: number;
                readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment" | "ReplyListContainer6_comment">;
            };
        }>;
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_comment">;
    readonly " $refType": "ReplyListContainer5_comment";
};
export type ReplyListContainer5_comment$data = ReplyListContainer5_comment;
export type ReplyListContainer5_comment$key = {
    readonly " $data"?: ReplyListContainer5_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer5_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "kind": "Variable",
        "name": "refreshStream",
        "variableName": "refreshStream"
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "replyCount",
        "storageKey": null
    } as any), v3 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "ReplyListCommentContainer_comment"
    } as any), v4 = [
        (v1 /*: any*/)
    ], v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 10,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_ASC",
                "kind": "LocalArgument",
                "name": "orderBy"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "refreshStream"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "replies"
                    ]
                }
            ]
        },
        "name": "ReplyListContainer5_comment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "alias": "replies",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    },
                    (v1 /*: any*/)
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__ReplyList_replies_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v2 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    (v3 /*: any*/),
                                    {
                                        "args": (v4 /*: any*/),
                                        "kind": "FragmentSpread",
                                        "name": "ReplyListContainer6_comment"
                                    }
                                ],
                                "storageKey": null
                            },
                            (v5 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "viewNewEdges",
                                "plural": true,
                                "selections": [
                                    (v5 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v2 /*: any*/),
                                            (v3 /*: any*/),
                                            {
                                                "args": null,
                                                "kind": "FragmentSpread",
                                                "name": "ReplyListContainer6_comment"
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ]
                    }
                ],
                "storageKey": null
            },
            {
                "args": (v4 /*: any*/),
                "kind": "FragmentSpread",
                "name": "ReplyListContainer_comment"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastViewerAction",
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1b2f57c1edaacb81ea5968e3f62f03a7';
export default node;
